import React, { useState, useEffect } from "react";
import { Container, Row, Col, Form, Button, Table, Card } from "react-bootstrap";
import heroBg from "../assets/images/HeroBanner.png";
import { useNavigate } from "react-router-dom";
import "../styles/PresidentSecretary.css";
import { ChevronLeft, ChevronRight } from "lucide-react";


const PresidentSecretary = () => {
  const navigate = useNavigate();
  const [tokenState, setTokenState] = useState(localStorage.getItem("token"));

  useEffect(() => {
    const interval = setInterval(() => {
      const currentToken = localStorage.getItem("token");
      if (currentToken !== tokenState) {
        setTokenState(currentToken);
      }
    }, 500);
    return () => clearInterval(interval);
  }, [tokenState]);

  const handleMemberLogin = () => {
    navigate("/member-login");
  };

  const handleEdcclogin = () => {
    navigate("/edcc-login");
  };

  return (
    <>
      {/* Fixed Hero Section */}
      <section
        className="hero-fixed"
        style={{ backgroundImage: `url(${heroBg})` }}
      >
        <div className="hero-scroll-content">
          <div className="hero-content-home poppins-regular">
            <h1 className="hero-heading">
              All India Occupational Therapists' Association
            </h1>
            {!tokenState && (
              <div className="hero-buttons">
                <button className="glass-button" onClick={handleMemberLogin}>
                  Member Login
                </button>
                <button className="glass-button" onClick={handleEdcclogin}>
                  Ergonomic Certificate login
                </button>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Scrollable Content Container */}
      <div className="scrollable-content-home">
        <div className="content-container">
          <section className="president-secretary-section">
            <Container>
              <h2 className="president-secretary-heading">Presidents & Secretaries (AIOTA) and Dean (ACOT)</h2>

              <h6>1952 - 2028</h6>
              <h5>Founder President: Dr. Kamala V. Nimbkar</h5>
              <Card className="p-0 president-secretary-card mt-3">
                <Table bordered responsive className="president-secretary-table">
                  <thead>
                    <tr>
                      <th>
                        <div className="heading">PRESIDENT</div>
                        <div className="year">(1952-1989)</div>
                      </th>
                      <th>
                        <div className="heading">PRESIDENT</div>
                        <div className="year">(1990 Onwards)</div>
                      </th>
                      <th>
                        <div className="heading">SECRETARY</div>
                        <div className="year">(1952-1989)</div>
                      </th>
                      <th>
                        <div className="heading">SECRETARY</div>
                        <div className="year">(1990 Onwards)</div>
                      </th>
                      <th>
                        <div className="heading">DEAN ACOT</div>
                        <div className="year">(1984-2028)</div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td><div className="name">Dr. Kamala V. Nimbkar</div></td>
                      <td><div className="name">Dr. N.R. Chitnavis
                        (1990-1991)</div></td>
                      <td>
                        <div className="name">Dr. Ramesh Oza</div>

                      </td>
                      <td>
                        <div className="name">Dr. S.L. Rai</div>
                        <div className="tenure">(1990-1991)</div>
                      </td>
                      <td>
                        <div className="name">Dr. M.G. Rao</div>
                        <div className="tenure">(1984-1988)</div>
                      </td>
                    </tr>
                    <tr>
                      <td><div className="name">Dr. Ramesh Oza</div></td>
                      <td><div className="name">
                        Dr. Madan S. Warhade
                        (1992-1993)</div></td>
                      <td>
                        Dr. Glenda Lopes
                      </td>
                      <td>
                        <div className="name">Dr. V.S. Thombre</div>
                        <div className="tenure">(1992-1993)</div>
                      </td>
                      <td>
                        <div className="name">Dr. Meera M. Shahani</div>
                        <div className="tenure">(1988-1992)</div>
                      </td>
                    </tr>
                    <tr>
                      <td><div className="name">Dr. Glenda Lopes</div></td>
                      <td><div className="name">Dr. R.K. Sharma
                        (1994-2002)</div></td>
                      <td>
                        <div className="name">Dr. Pavri</div>

                      </td>
                      <td>
                        <div className="name">Dr. Anil K. Srivastava</div>
                        <div className="tenure">(1994-1996)</div>
                      </td>
                      <td>
                        <div className="name">Dr. Nirmala R. Chitnavis</div>
                        <div className="tenure">(1992-1996)</div>
                      </td>
                    </tr>
                    <tr>
                      <td><div className="name">Dr. M.R. Kulkarni</div></td>
                      <td><div className="name">Dr. Anil K. Srivastava
                        (2002-2010)</div></td>
                      <td>
                        <div className="name">Dr. M.R. Kulkarni</div>

                      </td>
                      <td>
                        <div className="name">Dr. Odette Gomes</div>
                        <div className="tenure">(1996-1998)</div>
                      </td>
                      <td>
                        <div className="name">Dr. Indira R. Kenkre</div>
                        <div className="tenure">(1996-2004)</div>
                      </td>
                    </tr>
                    <tr>
                      <td><div className="name">Dr. M.G. Deo</div></td>
                      <td><div className="name">Dr. Madan S. Warhade (2010-2012)</div></td>
                      <td>
                        <div className="name">Dr. Meera M. Shahani</div>

                      </td>
                      <td>
                        <div className="name">Dr. Sunil P. Mokashi</div>
                        <div className="tenure">(1998-2000)</div>
                      </td>
                      <td>
                        <div className="name">Dr. R.K. Sharma</div>
                        <div className="tenure">(2004-2008)</div>
                      </td>
                    </tr>
                    <tr>
                      <td><div className="name">Dr. G.H. Purohit</div></td>
                      <td><div className="name">Dr. Anil K. Srivastava (2012-2024)</div></td>
                      <td>
                        <div className="name">Dr. Ashutosh Purohit</div>

                      </td>
                      <td>
                        <div className="name">Dr. Zarine D. Ferzandi</div>
                        <div className="tenure">(2000-2002)</div>
                      </td>
                      <td>
                        <div className="name">Dr. Madan S. Warhade</div>
                        <div className="tenure">(2008-2012)</div>
                      </td>
                    </tr>
                    <tr>
                      <td><div className="name"></div></td>
                      <td><div className="name">Dr. Pankaj Bajpai
                        (2024-2028)</div></td>
                      <td>
                        <div className="name">Dr. A.C. Shrivastava</div>

                      </td>
                      <td>
                        <div className="name">Dr. Shovan Saha</div>
                        <div className="tenure">(2002-2004)</div>
                      </td>
                      <td>
                        <div className="name">Dr. Jyothika N. Bijlani
                          (2012 - 2028)</div>

                      </td>
                    </tr>
                    <tr>
                      <td></td>
                      <td></td>
                      <td>
                        <div className="name">Dr. Madan S. Warhade</div>

                      </td>
                      <td>
                        <div className="name">Dr. Pankaj Bajpai(2004 - 2006)</div>

                      </td>
                      <td>


                      </td>
                    </tr>
                    <tr>
                      <td></td>
                      <td></td>
                      <td>
                        <div className="name">Dr. Indira Kenkre</div>

                      </td>
                      <td>
                        <div className="name">
                          Dr. Shovan Saha</div>
                        <div className="tenure">(2008 - 2012)</div>
                      </td>
                      <td></td>
                    </tr>
                    <tr>
                      <td></td>
                      <td></td>
                      <td>


                      </td>
                      <td>
                        <div className="name">
                          Dr. Pankaj Bajpai</div>
                        <div className="tenure">(2012 - 2016)</div>
                      </td>
                      <td></td>
                    </tr>
                    <tr>
                      <td></td>
                      <td></td>
                      <td>


                      </td>
                      <td>
                        <div className="name">
                          Dr. Satish Maslekar</div>
                        <div className="tenure">(2016 - 2020)</div>
                      </td>
                      <td></td>
                    </tr>
                    <tr>
                      <td></td>
                      <td></td>
                      <td>


                      </td>
                      <td>
                        <div className="name">
                          Dr. Joseph Sunny </div>
                        <div className="tenure">(2020 - 2024)</div>
                      </td>
                      <td></td>
                    </tr>
                    <tr>
                      <td></td>
                      <td></td>
                      <td>


                      </td>
                      <td>
                        <div className="name">
                          Dr. Joseph Sunny</div>
                        <div className="tenure">(2024 - 2028)</div>
                      </td>
                 
                    </tr>
                   
                  </tbody>
                </Table>
              </Card>


            </Container>
          </section>
        </div>
      </div>
    </>
  );
};

export default PresidentSecretary;
